/* eslint-disable @typescript-eslint/no-explicit-any */
import type { FetchConfig } from "../contexts";

export const convertFetchResponse = async (
  response: Response,
  config: FetchConfig,
) => {
  let data: any = null;

  // Check if a specific response type is requested
  if (config.responseType) {
    try {
      switch (config.responseType) {
        case "blob":
          data = await response.blob();
          break;
        case "arraybuffer":
          data = await response.arrayBuffer();
          break;
        case "text":
          data = await response.text();
          break;
        default:
          data = await response.json();
          break;
      }
    } catch (error) {
      console.error(
        `[APIProvider] Failed to parse response as ${config.responseType}`,
        error,
      );
    }
  } else {
    // Auto-detect based on content-type
    const contentType = response.headers.get("content-type");
    if (contentType?.includes("application/json")) {
      try {
        data = await response.json();
      } catch (error) {
        console.error("[APIProvider] Failed to parse JSON response", error);
      }
    } else {
      try {
        data = await response.text();
      } catch (error) {
        console.error("[APIProvider] Failed to parse text response", error);
      }
    }
  }

  return {
    data,
    status: response.status,
    statusText: response.statusText,
    headers: response.headers,
    config,
    request: {},
  };
};
